import script from "./RandomFile.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomFile.vue?vue&type=script&setup=true&lang=js"

import "./RandomFile.vue?vue&type=style&index=0&id=4cd71082&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd71082"]])

export default __exports__